import { Link } from 'react-router-dom';
import { EmptyCell, FormattedDateTime } from 'components';
import { MeterIdCell } from 'components/table/cells/MeterIdCell';
import type { ColumnsType } from 'antd/lib/table';
import type { InventoryMeterListData } from 'routes/dashboard/hooks/useCardInventoryMeters';
import { MeterDetailParent } from '../../../portfolio/locations/enums/MeterDetailParent';
import { MetersCardTab } from '../../enums/MeterCardTab';

const SHARED_COLUMNS: ColumnsType<InventoryMeterListData['data'][number]> = [
  {
    title: 'ID',
    key: 'id',
    render: (_, meter) => (
      <MeterIdCell
        enmonMeterId={meter._id}
        inventoryMeterId={meter.id}
        isActive={meter.isActive}
        mergedAt={meter.merged_at}
        mergedIntoId={meter.merged_into?.id}
      />
    ),
  },
  {
    title: 'Customer name',
    key: 'customer.name',
    width: 250,
    render: (_, meter) => meter?.inventory_location?.customer?.name ?? <EmptyCell />,
  },
  {
    title: 'What it monitors',
    key: 'monitored_entity',
    render: (_, { id, name, _id }) => (
      <Link to={{ pathname: `/portfolio/meters/${id ?? _id}`, state: { parent: MeterDetailParent.Dashboard } }}>
        {name ?? id}
      </Link>
    ),
  },
  {
    title: 'Serial Number',
    dataIndex: 'serial_number',
    key: 'serial_number',
  },
];

export const getInventoryMetersTableColumns = (
  activeMetersTab: MetersCardTab,
): ColumnsType<InventoryMeterListData['data'][number]> => {
  switch (activeMetersTab) {
    case MetersCardTab.Pasport:
      return [
        ...SHARED_COLUMNS,
        {
          title: 'Pasported At',
          dataIndex: 'submitted_at',
          key: 'submitted_at',
          render: value => (value ? <FormattedDateTime date={value} /> : <EmptyCell />),
        },
      ];

    case MetersCardTab.Update:
      return [
        ...SHARED_COLUMNS,
        {
          title: 'Updated At',
          dataIndex: 'updatedAt',
          key: 'updatedAt',
          render: value => (value ? <FormattedDateTime date={value} /> : <EmptyCell />),
        },
      ];
    case MetersCardTab.Replace:
      return [
        ...SHARED_COLUMNS,
        {
          title: 'Replaced At',
          dataIndex: 'replaced_at',
          key: 'replaced_at',
          render: value => (value ? <FormattedDateTime date={value} /> : <EmptyCell />),
        },
      ];
    case MetersCardTab.Install:
      return [
        ...SHARED_COLUMNS,
        {
          title: 'Installed At',
          dataIndex: 'installed_at',
          key: 'installed_at',
          render: value => (value ? <FormattedDateTime date={value} /> : <EmptyCell />),
        },
      ];
    case MetersCardTab.Service:
      return [
        ...SHARED_COLUMNS,
        {
          title: 'Serviced At',
          dataIndex: 'serviced_at',
          key: 'serviced_at',
          render: value => (value ? <FormattedDateTime date={value} /> : ' - '),
        },
        {
          title: 'Serviced By',
          dataIndex: 'serviced_by',
          key: 'serviced_by',
        },
      ];
    default:
      return [...SHARED_COLUMNS];
  }
};
